import {
  AllocationGroup,
  CheckoutBundleSlot,
  CheckoutEntry,
  CheckoutProfileService,
  CheckoutResponse,
  IFulfillmentTypesAndStoreMap,
  PincodeReqPayloadType,
  getValueCheck,
  getAddressLineExtended,
  isProxyOrder,
  checkoutFulfillmentOptions,
  isGroupOrder,
  Profile,
  isEasyDeliveryOrBopisOption,
} from '@commerce-checkout-webcomponents/sdk';
import { downlineAddressType } from '@commerce-profile-webcomponents/sdk';
import { useReducer } from 'react';
import { ApiConfigService, uniqueId } from '@nextgen-web-framework/core';
import { BundleItem, LineItem, getStoresByFulfillmentTypeProps } from '@commerce-fulfillment-webcomponents/sdk';
import { Cart, OrderType, Profile as CartProfile, SubCartDetail } from '@commerce-cart-webcomponents/sdk';
import {
  ContactTypeEnum,
  ICheckoutFulfillmentEntries,
  ICheckoutShippingAddressDetailsProps,
  ICheckoutShippingConfirmedAddressProps,
  ICheckoutShippingSelectedAddressProps,
  IDownlineAddressListMap,
  IShippingInitialState,
} from '../../checkout-shipping-details/types/propTypes';
import {
  ShippingTypeEnums,
  checkoutShippingDetailsActions,
  DataTypesEnums,
  softFilterObject,
  storeDetailsData,
  fulfillmentStorePaginationLimit,
  amwayStorePaginationLimit,
  edpStorePaginationLimit,
} from '../config/checkoutConstants';
import { findMainCart, isObjectEmpty } from '../transformer';
import { ICheckoutAnyType } from '../types/CheckoutType';

export const shippingDetailsInitialState: IShippingInitialState = {
  shippingDetailsData: null,
  displayAddNewAddressForDelivery: false,
  displayAddNewAddressForPickup: false,
  displayConfirmedAddress: false,
  displayAddressSelection: false,
  displayAddressBook: false,
  isDeliveryAddressAvailable: false,
  isPickupAddressAvailable: false,
  deliveryAddress: null,
  storePickupAddress: null,
  fulfillmentTypeForpickup: '',
  shippingType: '',
  softFilters: softFilterObject,
  locationPermission: '',
  isAddressSavedFlag: true,
  shippingDetailsUpdating: false,
};

export const shippingDetailsPickupDrawerInitialState = {
  storeOptionsData: [],
  selectedStoreId: '',
  recipientContact: '',
  recipientCountryCode: '',
  storePin: '',
  storeTypeOptions: [],
  storeMap: [],
  storeOptionName: '',
  pickupDrawerLoading: false,
  storeDetailsDrawerVisibility: false,
  storeDetailsData: storeDetailsData,
  selectedServiceLocation: null,
  enableLocationCtaVisibility: false,
  pickupContactDrawerVisibility: false,
};

export const shippingDetailsPickupContactDrawerInitialState = {
  recipientContact: '',
  recipientEmail: '',
  recipientName: '',
  recipientCountryCode: '',
};

export type dispatchActionType = (arg0: { type: string; payload?: boolean | string | object | null }) => void;
export const shippingDetailsReducer = (state: any, action: { type: string; payload?: boolean | string | object }) => {
  switch (action.type) {
    case checkoutShippingDetailsActions.SET_SHIPPING_DETAILS_DATA:
      return { ...state, shippingDetailsData: action.payload };
    case checkoutShippingDetailsActions.SET_DISPLAY_ADD_NEW_ADDRESS_FOR_DELIVERY:
      return { ...state, displayAddNewAddressForDelivery: action.payload };
    case checkoutShippingDetailsActions.SET_DISPLAY_ADD_NEW_ADDRESS_FOR_PICKUP:
      return { ...state, displayAddNewAddressForPickup: action.payload };
    case checkoutShippingDetailsActions.SET_DISPLAY_CONFIRMED_ADDRESS:
      return { ...state, displayConfirmedAddress: action.payload };
    case checkoutShippingDetailsActions.SET_DISPLAY_ADDRESS_SELECTION:
      return { ...state, displayAddressSelection: action.payload };
    case checkoutShippingDetailsActions.SET_DISPLAY_ADDRESS_BOOK:
      return { ...state, displayAddressBook: action.payload };
    case checkoutShippingDetailsActions.IS_DELIVERY_ADDRESS_AVAILABLE:
      return { ...state, isDeliveryAddressAvailable: action.payload };
    case checkoutShippingDetailsActions.IS_PICKUP_ADDRESS_AVAILABLE:
      return { ...state, isPickupAddressAvailable: action.payload };
    case checkoutShippingDetailsActions.SHIPPING_ADDRESS:
      return { ...state, deliveryAddress: action.payload };
    case checkoutShippingDetailsActions.STORE_PICKUP_ADDRESS:
      return { ...state, storePickupAddress: action.payload };
    case checkoutShippingDetailsActions.SET_SHIPPING_TYPE:
      return { ...state, shippingType: action.payload };
    case checkoutShippingDetailsActions.SET_SOFT_FILTERS:
      return { ...state, softFilters: action.payload };
    case checkoutShippingDetailsActions.SET_LOCATION_PERMISSION:
      return { ...state, locationPermission: action.payload };
    case checkoutShippingDetailsActions.SET_IS_ADDRESS_SAVED_FLAG:
      return { ...state, isAddressSavedFlag: action.payload };
    case checkoutShippingDetailsActions.SET_PICKUP_CONTACT_DRAWER_VISIBILITY:
      return { ...state, pickupContactDrawerVisibility: action.payload };
    case checkoutShippingDetailsActions.SET_FULFILLMENT_TYPE_FOR_PICKUP:
      return { ...state, fulfillmentTypeForpickup: action.payload };
    case checkoutShippingDetailsActions.SET_SHIPPING_DETAILS_UPDATING:
      return { ...state, shippingDetailsUpdating: action.payload };
    default:
      return state;
  }
};

export const shippingDetailsPickupDrawerReducer = (
  state: ICheckoutAnyType,
  action: { type: string; payload?: string | object | boolean },
) => {
  switch (action.type) {
    case checkoutShippingDetailsActions.SET_STORE_OPTIONS_DATA:
      return { ...state, storeOptionsData: action.payload };
    case checkoutShippingDetailsActions.SET_SELECTED_STORE_ID:
      return { ...state, selectedStoreId: action.payload };
    case checkoutShippingDetailsActions.SET_RECIPIENT_CONTACT:
      return { ...state, recipientContact: action.payload };
    case checkoutShippingDetailsActions.SET_RECIPIENT_COUNTRY_CODE:
      return { ...state, recipientCountryCode: action.payload };
    case checkoutShippingDetailsActions.SET_STORE_PIN:
      return { ...state, storePin: action.payload };
    case checkoutShippingDetailsActions.SET_STORE_TYPE_OPTIONS:
      return { ...state, storeTypeOptions: action.payload };
    case checkoutShippingDetailsActions.SET_STORE_MAP:
      return { ...state, storeMap: action.payload };
    case checkoutShippingDetailsActions.SET_STORE_OPTION_NAME:
      return { ...state, storeOptionName: action.payload };
    case checkoutShippingDetailsActions.SET_PICKUP_DRAWER_LOADING:
      return { ...state, pickupDrawerLoading: action.payload };
    case checkoutShippingDetailsActions.SET_STORE_DETAILS_DRAWER_VISIBILITY:
      return { ...state, storeDetailsDrawerVisibility: action.payload };
    case checkoutShippingDetailsActions.SET_STORE_DETAILS_DATA:
      return { ...state, storeDetailsData: action.payload };
    case checkoutShippingDetailsActions.SET_SELECTED_SERVICE_LOCATION:
      return { ...state, selectedServiceLocation: action.payload };
    case checkoutShippingDetailsActions.SET_ENABLE_LOCATION_CTA_VISIBILITY:
      return { ...state, enableLocationCtaVisibility: action.payload };
    default:
      return state;
  }
};

export const shippingDetailsPickupContactDrawerReducer = (
  state: ICheckoutAnyType,
  action: { type: string; payload?: string | object | boolean },
) => {
  switch (action.type) {
    case checkoutShippingDetailsActions.SET_RECIPIENT_CONTACT:
      return { ...state, recipientContact: action.payload };
    case checkoutShippingDetailsActions.SET_RECIPIENT_NAME:
      return { ...state, recipientName: action.payload };
    case checkoutShippingDetailsActions.SET_RECIPIENT_EMAIL:
      return { ...state, recipientEmail: action.payload };
    default:
      return state;
  }
};

export const getSoftFilterKey = (shippingType: string) =>
  shippingType == ShippingTypeEnums.DELIVERY
    ? ShippingTypeEnums.DELIVERY.toLocaleLowerCase()
    : ShippingTypeEnums.PICKUP.toLocaleLowerCase();

export const checkPickupExist = (fulfillmentTypesAndStoreMap: IFulfillmentTypesAndStoreMap) => {
  let isPickUpExist = false;
  fulfillmentTypesAndStoreMap?.pickUp &&
    Object.keys(fulfillmentTypesAndStoreMap?.pickUp).forEach((pickup) => {
      fulfillmentTypesAndStoreMap?.pickUp[pickup].isExist && (isPickUpExist = true);
    });
  return isPickUpExist;
};

export const triggerChangeShipping = (dispatchShippingStateAction: dispatchActionType) => {
  dispatchShippingStateAction({
    type: checkoutShippingDetailsActions.SET_DISPLAY_CONFIRMED_ADDRESS,
    payload: false,
  });
  dispatchShippingStateAction({
    type: checkoutShippingDetailsActions.SET_DISPLAY_ADDRESS_SELECTION,
    payload: true,
  });
};

const validatingShippingTypeAndChangeHandler = (
  shippingType: string,
  fulfillmentTypesAndStoreMap: IFulfillmentTypesAndStoreMap,
) => {
  let changeShippingType = shippingType;
  let triggerChange = false;
  const isPickupExist = checkPickupExist(fulfillmentTypesAndStoreMap);
  if (shippingType == ShippingTypeEnums.DELIVERY && !fulfillmentTypesAndStoreMap?.delivery?.isExist && isPickupExist) {
    changeShippingType = ShippingTypeEnums.PICKUP;
    triggerChange = true;
  }
  if (shippingType == ShippingTypeEnums.PICKUP && !isPickupExist) {
    changeShippingType = ShippingTypeEnums.DELIVERY;
    triggerChange = true;
  }
  return { shippingType: changeShippingType || ShippingTypeEnums.DELIVERY, triggerChange };
};

export const setShippingTypeRestricted = (
  shippingType: string,
  dispatchShippingStateAction: dispatchActionType,
  isRestricted?: boolean,
) => {
  const softFilterKey = getSoftFilterKey(shippingType);
  dispatchShippingStateAction({
    type: checkoutShippingDetailsActions.SET_SOFT_FILTERS,
    payload: {
      [softFilterKey]: {
        message: `checkout.CheckoutShippingDetailsContainer.${softFilterKey}NotAvailable`,
        isVisible: isRestricted || false,
      },
    },
  });
};

export const validateFulfillmentTypesAndStoreMap = (
  currentShippingType: string,
  fulfillmentTypesAndStoreMap: IFulfillmentTypesAndStoreMap,
  dispatchShippingStateAction: dispatchActionType,
) => {
  const { shippingType, triggerChange } = validatingShippingTypeAndChangeHandler(
    getValueCheck(currentShippingType, DataTypesEnums.TYPE_STRING),
    fulfillmentTypesAndStoreMap,
  );
  dispatchShippingStateAction({
    type: checkoutShippingDetailsActions.SET_SHIPPING_TYPE,
    payload: shippingType,
  });
  if (triggerChange) {
    triggerChangeShipping(dispatchShippingStateAction);
  }
};

export const shippingDetailsUseEffect = (
  shippingDetails: ICheckoutShippingAddressDetailsProps,
  dispatchShippingStateAction: dispatchActionType,
  isRestricted?: boolean,
) => {
  const isDeliveryAddressAvailable = !isObjectEmpty(shippingDetails?.deliveryAddress);
  const isPickupAddressAvailable = !isObjectEmpty(shippingDetails?.storePickupAddress);
  const shippingType = shippingDetails?.shippingType || ShippingTypeEnums.DELIVERY;
  dispatchShippingStateAction({
    type: checkoutShippingDetailsActions.SET_SHIPPING_TYPE,
    payload: shippingType,
  });
  setShippingTypeRestricted(shippingDetails?.shippingType, dispatchShippingStateAction, isRestricted);
  if (!isDeliveryAddressAvailable && !isPickupAddressAvailable) {
    dispatchShippingStateAction({ type: checkoutShippingDetailsActions.SET_DISPLAY_ADDRESS_SELECTION, payload: true });
    dispatchShippingStateAction({
      type: checkoutShippingDetailsActions.SET_DISPLAY_ADD_NEW_ADDRESS_FOR_DELIVERY,
      payload: true,
    });
    dispatchShippingStateAction({
      type: checkoutShippingDetailsActions.SET_DISPLAY_ADD_NEW_ADDRESS_FOR_PICKUP,
      payload: true,
    });
  } else if (shippingDetails?.shippingType == ShippingTypeEnums.DELIVERY && isDeliveryAddressAvailable) {
    dispatchShippingStateAction({
      type: checkoutShippingDetailsActions.SHIPPING_ADDRESS,
      payload: { ...shippingDetails.deliveryAddress, contactType: ContactTypeEnum.SHIPPING },
    });
    dispatchShippingStateAction({
      type: checkoutShippingDetailsActions.STORE_PICKUP_ADDRESS,
      payload: isPickupAddressAvailable ? shippingDetails.storePickupAddress : null,
    });
    dispatchShippingStateAction({ type: checkoutShippingDetailsActions.IS_DELIVERY_ADDRESS_AVAILABLE, payload: true });
    dispatchShippingStateAction({
      type: checkoutShippingDetailsActions.IS_PICKUP_ADDRESS_AVAILABLE,
      payload: isPickupAddressAvailable,
    });
    dispatchShippingStateAction({ type: checkoutShippingDetailsActions.SET_DISPLAY_CONFIRMED_ADDRESS, payload: true });
    dispatchShippingStateAction({ type: checkoutShippingDetailsActions.SET_DISPLAY_ADDRESS_SELECTION, payload: false });
  } else if (isPickupAddressAvailable && shippingDetails?.shippingType == ShippingTypeEnums.PICKUP) {
    dispatchShippingStateAction({
      type: checkoutShippingDetailsActions.SHIPPING_ADDRESS,
      payload: isDeliveryAddressAvailable
        ? { ...shippingDetails.deliveryAddress, contactType: ContactTypeEnum.SHIPPING }
        : CheckoutProfileService?.getCheckoutProfile()?.fulfillmentType?.serviceLevel?.deliveryAddress || null,
    });
    dispatchShippingStateAction({
      type: checkoutShippingDetailsActions.STORE_PICKUP_ADDRESS,
      payload: shippingDetails?.storePickupAddress,
    });
    dispatchShippingStateAction({
      type: checkoutShippingDetailsActions.IS_DELIVERY_ADDRESS_AVAILABLE,
      payload: isDeliveryAddressAvailable,
    });
    dispatchShippingStateAction({ type: checkoutShippingDetailsActions.IS_PICKUP_ADDRESS_AVAILABLE, payload: true });
    dispatchShippingStateAction({ type: checkoutShippingDetailsActions.SET_DISPLAY_CONFIRMED_ADDRESS, payload: true });
    dispatchShippingStateAction({ type: checkoutShippingDetailsActions.SET_DISPLAY_ADDRESS_SELECTION, payload: false });
  }
  if (shippingDetails?.shippingTypeChangeFlow) {
    triggerChangeShipping(dispatchShippingStateAction);
  }
};

export const useShippingDetailsReducer = () => {
  const [state, dispatchShippingStateAction] = useReducer(shippingDetailsReducer, shippingDetailsInitialState);
  return [state, dispatchShippingStateAction];
};

export const checkFulfillmentOptions = (fulfillmentOptions?: Array<AllocationGroup>) => {
  const allocationOptionsAvailability = { isPickupAddressSelectable: false, isDeliveryAddressSelectable: false };
  fulfillmentOptions?.forEach((allocationGroup: AllocationGroup) => {
    allocationGroup?.fulfillmentType?.id == checkoutFulfillmentOptions.HOMEDELIVERY
      ? (allocationOptionsAvailability.isDeliveryAddressSelectable = true)
      : (allocationOptionsAvailability.isPickupAddressSelectable = true);
  });
  return allocationOptionsAvailability;
};

export const transformCheckoutDataToShippingDetails = (data: CheckoutResponse) => {
  const shippingDetailsData = {} as ICheckoutShippingAddressDetailsProps;
  const checkoutProfileData = CheckoutProfileService.getCheckoutProfile();
  shippingDetailsData.bopisDetails = data?.fulfillment?.bopisRecipientDetail?.mobileNo
    ? data?.fulfillment?.bopisRecipientDetail
    : {
        mobileNo: getValueCheck(data?.user?.mobileNo, DataTypesEnums.TYPE_STRING),
      };
  shippingDetailsData.deliveryAddress =
    data.fulfillment?.address || checkoutProfileData?.fulfillmentType?.serviceLevel?.deliveryAddress;
  shippingDetailsData.storePickupAddress =
    data?.fulfillment?.id != checkoutFulfillmentOptions.HOMEDELIVERY ? data?.fulfillment?.serviceLocation : null;
  shippingDetailsData.shippingType =
    data?.fulfillment?.id != checkoutFulfillmentOptions.HOMEDELIVERY
      ? ShippingTypeEnums.PICKUP
      : ShippingTypeEnums.DELIVERY;

  return {
    ...shippingDetailsData,
    ...checkFulfillmentOptions(data.fulfillmentOptions?.allocationGroups),
    ...transformCheckoutGcoDataToDownlinersList(data, data?.isOrderingUserCheckout),
  };
};

const getAddressLinesBasedOnShippingType = (shippingType: string, data: ICheckoutAnyType) => {
  if (shippingType == ShippingTypeEnums.DELIVERY) {
    return [
      `${getAddressLineExtended(data?.addrLineOne, 'coma')}
  ${getValueCheck(data?.addrLineTwo, DataTypesEnums.TYPE_STRING)}`,
      `${getAddressLineExtended(data?.subDistrict, 'coma')}
  ${getAddressLineExtended(data?.district, 'coma')}
  ${getValueCheck(data?.state, DataTypesEnums.TYPE_STRING)}`,
      `${getValueCheck(data?.postalCode, DataTypesEnums.TYPE_STRING)}`,
    ];
  }
  return [
    `${getAddressLineExtended(data?.address?.line1, 'coma')}
${getAddressLineExtended(data?.address?.line2, 'coma')}
${getAddressLineExtended(data?.address?.city, 'coma')}
${getAddressLineExtended(data?.address?.postCode, 'coma')}
${getValueCheck(data?.address?.country, DataTypesEnums.TYPE_STRING)}`,
    `${getValueCheck(data?.phone, DataTypesEnums.TYPE_STRING)}`,
  ];
};

export const transformCheckoutAddressToConfirmedAddress = (
  shippingType: string,
  data: ICheckoutAnyType,
  profileName?: string,
): ICheckoutShippingConfirmedAddressProps => {
  const confirmedAddress: ICheckoutShippingConfirmedAddressProps = {};
  confirmedAddress.shippingTagIcon = shippingType == ShippingTypeEnums.DELIVERY ? 'truck' : 'location-dot';
  confirmedAddress.shippingTagLabel =
    shippingType == ShippingTypeEnums.DELIVERY
      ? 'checkout.CheckoutConfirmedAddressDetails.shippingMethodDelivery'
      : 'checkout.CheckoutConfirmedAddressDetails.shippingMethodPickup';
  confirmedAddress.profileName = profileName;
  confirmedAddress.addressFields = [];
  confirmedAddress.addressFields.push({
    title:
      shippingType == ShippingTypeEnums.DELIVERY
        ? 'checkout.CheckoutConfirmedAddressDetails.deliveryLabel'
        : 'checkout.CheckoutConfirmedAddressDetails.pickupLabel',
    subTitle:
      shippingType == ShippingTypeEnums.DELIVERY
        ? getValueCheck(data?.contactNickname, DataTypesEnums.TYPE_STRING)
        : getValueCheck(data?.name, DataTypesEnums.TYPE_STRING),
    storeId: shippingType == ShippingTypeEnums.PICKUP && getValueCheck(data?.id, DataTypesEnums.TYPE_STRING),
    imageUrl: getValueCheck(data?.imageUrl, DataTypesEnums.TYPE_STRING),
    addressValues: getAddressLinesBasedOnShippingType(shippingType, data),
    instructions: getAddressLineExtended(data?.deliveryInstructions, 'quote'),
    ...(shippingType == ShippingTypeEnums.DELIVERY && {
      recipientName: `${getAddressLineExtended(data?.recipientFirstName, 'space')}${getAddressLineExtended(
        data?.recipientLastName,
        'space',
      )}`,
      recipientContact: data?.phone,
    }),
  });
  if (shippingType == ShippingTypeEnums.PICKUP && data?.mobileNo) {
    confirmedAddress.addressFields?.push({
      title: 'checkout.CheckoutConfirmedAddressDetails.pickupContact',
      recipientContact: `${data?.countryCode ?? ''}${data?.mobileNo ?? ''}`,
      pickupRecipientName: data?.recipientName,
      pickupRecipientEmail: data?.email,
    });
  }
  return confirmedAddress;
};

export const transformCheckoutAddressToSelectedAddress = (
  shippingType: string,
  data: ICheckoutAnyType,
): ICheckoutShippingSelectedAddressProps => {
  const selectedAddress: ICheckoutShippingSelectedAddressProps = {};
  selectedAddress.heading =
    shippingType == ShippingTypeEnums.DELIVERY
      ? 'checkout.CheckoutSelectedAddressCard.titleTypeDelivery'
      : 'checkout.CheckoutSelectedAddressCard.titleTypePickup';
  selectedAddress.title =
    shippingType == ShippingTypeEnums.PICKUP
      ? getValueCheck(data?.name, DataTypesEnums.TYPE_STRING)
      : getValueCheck(data?.contactNickname, DataTypesEnums.TYPE_STRING);
  selectedAddress.storeId =
    shippingType == ShippingTypeEnums.PICKUP ? getValueCheck(data?.id, DataTypesEnums.TYPE_STRING) : '';
  selectedAddress.imageUrl = getValueCheck(data?.imageUrl, DataTypesEnums.TYPE_STRING);
  selectedAddress.addressValues = getAddressLinesBasedOnShippingType(shippingType, data);
  selectedAddress.instructions = getAddressLineExtended(data?.deliveryInstructions, 'quote');
  if (shippingType == ShippingTypeEnums.DELIVERY) {
    selectedAddress.recipientName = `${getAddressLineExtended(
      data?.recipientFirstName,
      'space',
    )}${getAddressLineExtended(data?.recipientLastName, 'space')}`;
    selectedAddress.recipientContact = data?.phone;
  }
  return selectedAddress;
};

const getDownlinersDetailObj = (data: CheckoutResponse) => {
  if (!data?.account?.profiles?.length) {
    return {
      firstName: getValueCheck(data?.user?.firstName, DataTypesEnums.TYPE_STRING),
      lastName: getValueCheck(data?.user?.lastName, DataTypesEnums.TYPE_STRING),
      accountId: getValueCheck(data?.user?.accountId, DataTypesEnums.TYPE_STRING),
      ownerId: getValueCheck(data?.user?.id, DataTypesEnums.TYPE_STRING),
    };
  }
  const downlinerDetailsObj = { accountId: data?.account?.accountId } as downlineAddressType & ICheckoutAnyType;
  data?.account?.profiles?.forEach((profile: Profile) => {
    if (profile?.isPrimary) {
      downlinerDetailsObj.firstName = getValueCheck(profile?.firstName, DataTypesEnums.TYPE_STRING);
      downlinerDetailsObj.lastName = getValueCheck(profile?.lastName, DataTypesEnums.TYPE_STRING);
      downlinerDetailsObj.ownerId = getValueCheck(profile?.id, DataTypesEnums.TYPE_STRING);
    } else {
      if (profile?.id) {
        downlinerDetailsObj.coApplicantIds = [profile.id];
        downlinerDetailsObj.coApplicantFname = getValueCheck(profile?.firstName, DataTypesEnums.TYPE_STRING);
        downlinerDetailsObj.coApplicantLname = getValueCheck(profile?.lastName, DataTypesEnums.TYPE_STRING);
      }
    }
  });
  return downlinerDetailsObj;
};

const getDownlinersDetailFromCart = (data: SubCartDetail) => {
  if (!data?.amwayUser?.profiles?.length) {
    return {
      firstName: getValueCheck(data?.amwayUser?.firstName, DataTypesEnums.TYPE_STRING),
      lastName: getValueCheck(data?.amwayUser?.lastName, DataTypesEnums.TYPE_STRING),
      accountId: getValueCheck(data?.amwayUser?.accountId, DataTypesEnums.TYPE_STRING),
      ownerId: getValueCheck(data?.amwayUser?.amwayUserId, DataTypesEnums.TYPE_STRING),
    };
  }
  const downlinerDetailsObj = { accountId: data?.amwayUser?.accountId } as downlineAddressType & ICheckoutAnyType;
  data?.amwayUser?.profiles?.forEach((profile: CartProfile) => {
    if (profile?.primary) {
      downlinerDetailsObj.firstName = getValueCheck(profile?.displayGivenName, DataTypesEnums.TYPE_STRING);
      downlinerDetailsObj.lastName = getValueCheck(profile?.displayFamilyName, DataTypesEnums.TYPE_STRING);
      downlinerDetailsObj.ownerId = getValueCheck(profile?.profileId, DataTypesEnums.TYPE_STRING);
    } else {
      if (profile?.profileId) {
        downlinerDetailsObj.coApplicantIds = [profile.profileId];
        downlinerDetailsObj.coApplicantFname = getValueCheck(profile?.displayGivenName, DataTypesEnums.TYPE_STRING);
        downlinerDetailsObj.coApplicantLname = getValueCheck(profile?.displayFamilyName, DataTypesEnums.TYPE_STRING);
      }
    }
  });
  return downlinerDetailsObj;
};

const getDownlinerName = (firstName?: string, lastName?: string) =>
  `${getValueCheck(firstName, DataTypesEnums.TYPE_STRING)} ${getValueCheck(lastName, DataTypesEnums.TYPE_STRING)}`;

export const transformCheckoutGcoDataToDownlinersList = (data: CheckoutResponse, isOrderingUserCheckout?: boolean) => {
  if (!isGroupOrder(data) && !isProxyOrder(data)) {
    return undefined;
  }
  const downlineAddressList: (downlineAddressType & ICheckoutAnyType)[] = [];
  const downlineAddressListMap: IDownlineAddressListMap = {};

  if (!isOrderingUserCheckout) {
    const downlinerDetailObj: downlineAddressType & ICheckoutAnyType = getDownlinersDetailObj(data);
    downlineAddressListMap[downlinerDetailObj.ownerId] = getDownlinerName(
      downlinerDetailObj.firstName,
      downlinerDetailObj.lastName,
    );
    if (downlinerDetailObj?.coApplicantIds?.length) {
      downlineAddressListMap[downlinerDetailObj.coApplicantIds[0]] = getDownlinerName(
        downlinerDetailObj.coApplicantFname,
        downlinerDetailObj.coApplicantLname,
      );
    }
    downlineAddressList?.push(downlinerDetailObj);
  }
  data.childCheckouts?.length &&
    data.childCheckouts.map((childCheckoutObj: CheckoutResponse) => {
      const downlinerDetailObj: downlineAddressType & ICheckoutAnyType = getDownlinersDetailObj(childCheckoutObj);
      downlineAddressListMap[downlinerDetailObj.ownerId] = getDownlinerName(
        downlinerDetailObj.firstName,
        downlinerDetailObj.lastName,
      );
      if (downlinerDetailObj?.coApplicantIds?.length) {
        downlineAddressListMap[downlinerDetailObj.coApplicantIds[0]] = getDownlinerName(
          downlinerDetailObj.coApplicantFname,
          downlinerDetailObj.coApplicantLname,
        );
      }
      downlineAddressList?.push(downlinerDetailObj);
    });

  return downlineAddressList.length > 0 ? { downlineAddressList, downlineAddressListMap } : undefined;
};

export const transformCartDataToDownlinersList = (data: Cart) => {
  if (data?.orderType == OrderType.Regular) {
    return undefined;
  }
  const mainCart = findMainCart(data?.subCarts || [], data.id);
  const downlineAddressList: (downlineAddressType & ICheckoutAnyType)[] = [];
  const downlineAddressListMap: IDownlineAddressListMap = {};
  data?.subCarts?.length &&
    data.subCarts.map((subCart: SubCartDetail) => {
      if (subCart?.subCartId != mainCart?.subCartId) {
        const downlinerDetailObj: downlineAddressType & ICheckoutAnyType = getDownlinersDetailFromCart(subCart);
        downlineAddressListMap[downlinerDetailObj.ownerId] = `${getValueCheck(
          downlinerDetailObj.firstName,
          DataTypesEnums.TYPE_STRING,
        )} ${getValueCheck(downlinerDetailObj.lastName, DataTypesEnums.TYPE_STRING)}`;
        if (downlinerDetailObj?.coApplicantIds?.length) {
          downlineAddressListMap[downlinerDetailObj.coApplicantIds[0]] = getDownlinerName(
            downlinerDetailObj.coApplicantFname,
            downlinerDetailObj.coApplicantLname,
          );
        }
        downlineAddressList?.push(downlinerDetailObj);
      }
    });

  return downlineAddressList.length > 0 ? { downlineAddressList, downlineAddressListMap } : undefined;
};

export const transformCheckoutEntriesLineItems = (
  entries?: Array<CheckoutEntry>,
  currencyIsoCode?: string,
): ICheckoutFulfillmentEntries => {
  const lineItems: Array<LineItem> = [];
  const bundleItems: Array<BundleItem> = [];
  entries?.map((entry) => {
    entry?.bundleSlots?.length
      ? entry.bundleSlots.map((bundleSlot: CheckoutBundleSlot) => {
          const transformedLineItems = transformCheckoutEntriesLineItems(bundleSlot?.entries, currencyIsoCode);
          bundleItems.push({
            bundleId: entry?.product?.id,
            bundleQuantity: entry?.quantity,
            lineItems: transformedLineItems.lineItems,
          });
        })
      : lineItems.push({
          //TODO Need to sync with fulfillment models
          lineId: entry?.entryId.toString(),
          itemId: entry?.product?.id,
          itemQuantity: entry?.quantity,
          lineAmount: {
            amount: entry?.totalPrice?.value,
            currency: getValueCheck(currencyIsoCode, DataTypesEnums.TYPE_STRING),
          },
          product: {
            productId: entry?.product?.id,
            hazardCode: entry?.product?.hazardAttributes?.hazardCode,
            dimension: {
              unit: entry?.product?.productDimensions?.length?.unit,
              length: entry?.product?.productDimensions?.length?.value,
              width: entry?.product?.productDimensions?.width?.value,
              height: Number(entry?.product?.productDimensions?.height?.unit),
            },
            weight: entry?.product?.productDimensions?.weight,
            flags: entry?.product?.flags,
          },
        });
  });
  return { lineItems, bundleItems };
};

const storesLimitByStoreName = (storeName: string) => {
  switch (storeName) {
    case checkoutFulfillmentOptions.BOPIS:
      return amwayStorePaginationLimit;
    case checkoutFulfillmentOptions.EASYDELIVERYPOINT:
      return edpStorePaginationLimit;
    default:
      return fulfillmentStorePaginationLimit;
  }
};

export const transformCheckoutToFulfillmentRequest = (
  entries: Array<CheckoutEntry>,
  storeChipName: string,
  storePin?: string,
  currencyIsoCode?: string,
  isStorePinSearchTriggered?: boolean,
  lat?: number,
  long?: number,
  lastEvaluatedKey?: string,
  pagination?: boolean,
): getStoresByFulfillmentTypeProps & PincodeReqPayloadType => {
  const fulfillmentRequest: (getStoresByFulfillmentTypeProps & PincodeReqPayloadType) | ICheckoutAnyType = {
    payload: {
      ...(lastEvaluatedKey && pagination && { lastEvaluatedKey }),
      allocations: [
        {
          id: uniqueId().toString(),
          fulfillmentTypeId: storeChipName,
          address: {
            ...(storePin && !isEasyDeliveryOrBopisOption(storeChipName) && { postCode: storePin }),
            country: ApiConfigService.getTuples()['X-Amway-Country'],
            ...(lat && !isStorePinSearchTriggered && { lat }),
            ...(long && !isStorePinSearchTriggered && { long }),
          },
          ...(entries?.length && currencyIsoCode && { ...transformCheckoutEntriesLineItems(entries, currencyIsoCode) }),
        },
      ],
      limit: storesLimitByStoreName(storeChipName),
    },
    ...(isStorePinSearchTriggered && { pincode: storePin || '' }),
    ...(pagination && { pagination }),
  };
  return fulfillmentRequest as getStoresByFulfillmentTypeProps & PincodeReqPayloadType;
};
